import { gql } from '@apollo/client';

import mutation from './mutation';
import storeAddressIds from './storeAddressesData';

export default gql`
	${storeAddressIds},
	${mutation}
`;
